import * as yup from "yup";

import { FORM_FIELDS } from "@constants/form";

export const CREATE_TICKET = FORM_FIELDS.E_TICKET.TICKET_DETAILS;

const { TYPE, CATEGORY, UNIT, SUBJECT, ISSUE_DETAILS, PRIORITY } =
  CREATE_TICKET;

export const createTicketFormValidation = yup.object().shape({
  [TYPE]: yup
    .number()
    .typeError("Type is required")
    .required("Type is required"),
  [CATEGORY]: yup
    .number()
    .typeError("Category is required")
    .required("Category is required"),
  [UNIT]: yup
    .number()
    .typeError("Unit is required")
    .required("Unit is required"),
  [SUBJECT]: yup.string().required("Subject is required"),
  [ISSUE_DETAILS]: yup.string().required("Issue Details is required"),
  [PRIORITY]: yup
    .number()
    .typeError("Priority is required")
    .required("Priority is required"),
});

export type CreateTicketFormDataType = yup.InferType<
  typeof createTicketFormValidation
>;
